export const ABORT_CONFIRMATION_MODAL = 'ABORT_CONFIRMATION_MODAL';
export const STOP_CONFIRMATION_MODAL = 'STOP_CONFIRMATION_MODAL';
